import { FieldRenderProps } from "@progress/kendo-react-form";
import { Input } from "@progress/kendo-react-inputs";
import { FunctionComponent, useEffect, useState } from "react";
import { Label } from "@progress/kendo-react-labels";
import React from "react";
import { toDigital, toMinutes } from "../../utils/utils";

const Time: FunctionComponent<FieldRenderProps> = props => {
    const {
        label,
        id,
        valid,
        disabled,
        optional,
        mins,
        value,
        onChange,
        ...others
    } = props;

    const [time, setTime] = useState<string>(toDigital(mins))
    //const theTime = React.useMemo(() => time === undefined ? toDigital(mins) : time, [mins, time]);
    const timeChanged = e => {
        let newVal = toMinutes(e.target.value);
        onChange({ value: newVal })
        //console.log('timeChanged', e.target.value, newVal)
        setTime(toDigital(newVal))
    }

    useEffect(() => {
        setTime(toDigital(mins))
    }, [mins])

    return (
        <>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}>
                {label}
            </Label>
            <Input {...others} value={time} disabled={disabled} placeholder={'0:00'} className='time-field' onBlur={timeChanged} onChange={(e) => setTime(e.target.value?.toString())} />

        </>
    )
}

export default Time